import { useContextCart } from '@/context/Cart'
import { Badge, IconButton } from '@mui/material'
import { useRouter, usePathname } from 'next/navigation'
import { FunctionComponent, useEffect, useState } from 'react'

import Image from 'next/image'
import { BottomMenuItem, BottomMenuItems, resolveImageUrl } from '@/utils/constants'
import { useLanguage } from '@/context/LanguageContext'

const MbaBottomNav: FunctionComponent = () => {
  const { state: cartState } = useContextCart()
  const { locale } = useLanguage()

  const [path, setPath] = useState('')
  const pathname = usePathname()

  useEffect(() => { handlePath() }, [pathname])

  const handlePath = (): void => {
    setPath(pathname)
  }

  const router = useRouter()
  return (
    <div className='md:hidden flex flex-row justify-evenly items-center bg-surfaceHigh fixed bottom-0 left-0 w-full p-4 border border-secondaryMidStroke h-20 z-10'>
      {
        BottomMenuItems.map((item: BottomMenuItem, i: number) => {
          if (item.name_en === 'Cart') {
            return (
              <div key={i} className='flex flex-col justify-center items-center'>
                <IconButton classes={{ root: 'p-2' }} onClick={() => router.push(item.pathname ?? '/shop')}>
                  <Badge showZero badgeContent={cartState.summary.quantity ?? 0} color='error'>
                    <Image width={22} height={22} draggable={false} src={resolveImageUrl((path === item.pathname ? item.activeIcon : item.icon))} alt='cart' />
                  </Badge>
                </IconButton>
                <span className={'text-sm' + (path === item.pathname ? ' text-primaryMain' : ' text-textMid')}>{locale === 'en' ? item.name_en : item.name_mn}</span>
              </div>
            )
          } else {
            return (
              <div key={i} className='flex flex-col justify-center'>
                <IconButton classes={{ root: 'p-2' }} onClick={() => router.push(item.pathname ?? '/shop')}>
                  <Image width={22} height={22} draggable={false} src={resolveImageUrl((path === item.pathname ? item.activeIcon : item.icon))} alt={item.name_en ?? item.name_mn} />
                </IconButton>
                <span className={'text-sm' + (path === item.pathname ? ' text-primaryMain' : ' text-textMid')}>{locale === 'en' ? item.name_en : item.name_mn}</span>
              </div>
            )
          }
        })
      }
    </div>
  )
}
export default MbaBottomNav
